// extracted by mini-css-extract-plugin
export default {"swatch":"SMLThemeSwatch_swatch__ulCBa","checked":"SMLThemeSwatch_checked__uGbhr","image":"SMLThemeSwatch_image__-WVI4","name":"SMLThemeSwatch_name__T2YZB"};